import React from 'react';
import loadable from '@loadable/component';

import type CMSModuleDefault from './index';

export const loadCMSModule = /* #__LOADABLE__ */ (): Promise<{
    default: typeof CMSModuleDefault;
}> => import(/* webpackChunkName: "CMS-module" */ './index');

const STUB_COMPONENT: React.FC = () => null;

export const Header = checkDEV(
    loadable(loadCMSModule, {
        resolveComponent: CMSModule =>
            CMSModule.default.navigation.components.Header,
    })
);

function checkDEV<T>(el: T): T {
    const { host } = window.location;
    const isPreview = host.includes('127.0.0.1') || host.includes('localhost');

    return __DEV__ || isPreview ? el : (STUB_COMPONENT as any);
}
